
export const disponibiliteOptions = [
    { value: 'immédiat', label: 'Immédiate' },
    { value: '1 mois', label: 'Dans 1 mois' },
    { value: '3 mois', label: 'Dans 3 mois' },
    { value: 'autre', label: 'Autre (sélectionner une date)' },
    { value: '1 mois preavis', label: 'Dans 1 mois preavis' },
    { value: '3 mois preavis', label: 'Dans 3 mois preavis' },
  ];

  export const languageLevelOptions = [
    { value: 'Débutant', label: 'Débutant' },
    { value: 'Intermédiaire', label: 'Intermédiaire' },
    { value: 'Avancé', label: 'Avancé' },
    { value: 'Langue maternelle', label: 'Langue maternelle' },
  ];

  export const languageOptions = [
    { value: 'Français', label: 'Français' },
    { value: 'Anglais', label: 'Anglais' },
    { value: 'Espagnol', label: 'Espagnol' },
    { value: 'Arabe', label: 'Arabe' },
  ];

    export const contractTypeOptions = [
      { value: 'CDI', label: 'CDI' },
      { value: 'Portage', label: 'Portage' },
      { value: 'Freelance', label: 'Freelance' },
    ];

    export const lieuxSouhaites = [
      "France", "Maroc"
    ]

    export const regionMaroc = [
      "Casablanca", "Rabat", "Tanger", "Marrakech"
    ]

    export const regionFrance = [
      "Île-de-France", "Auvergne-Rhône-Alpes", "Occitanie", "Provence-Alpes-Côte d’Azur"
    ]

    export const secteurOptions = [
      "Finance", "Tech", "Santé", "Éducation", "Énergie", "Construction"
    ];


    export const companySizeOptions = [
      { value: 'Startup', label: 'Startup' },
      { value: 'TPE', label: 'TPE' },
      { value: 'TME', label: 'TME' },
      { value: 'Grand groupe', label: 'Grand groupe' },
    ];

    export const workEnvironmentOptions = [
      { value: 'Présentiel', label: 'Présentiel' },
      { value: 'Télétravail partiel', label: 'Télétravail partiel' },
      { value: 'Télétravail ponctuel', label: 'Télétravail ponctuel' },
      { value: 'Télétravail total', label: 'Télétravail total' },
    ];

    // edit talent status
    export const statusOptionsRecruteur = [
      { value: '', label: 'Status' },
      { value: 'A traiter', label: 'À traiter' },
      { value: 'Qualifie attente controle', label: 'Qualifié' }
    ];

    // Mes talents status

    export const statusColorMapRecruteur = [
      {
        value: 'A traiter',
        label: 'A traiter',
        style: { backgroundColor: '#000000', color: 'white' }
      },
      {
        value: 'Qualifie attente controle',
        label: 'Qualifié',
        style: { backgroundColor: '#0076b6', color: 'white' }
      },
      {
        value: 'Recruté',
        label: 'Recruté',
        style: { backgroundColor: '#00a550', color: 'white' }
      },
      {
        value: 'Non défini',
        label: 'Non défini',
        style: { backgroundColor: '#00a550', color: 'white' }
      }
    ];
    
    //entreprise canditure detail status 
    export const entrepriseCandidatureStatus = [
        {
      value: 'A traiter', label: 'Candidature à traiter',
      style: { backgroundColor: '#000000', color: 'white' }
      },
      {
        value: 'Refusé avant entretien',  label: 'Refusé avant entretien',
        style: { backgroundColor: '#cd5c5c', color: 'white' }
      },
      {
        value: 'Accepté pour entretien', label: 'Accepté pour entretien',
        style: { backgroundColor: '#0076b6', color: 'white' } 
      },
      {
        value: 'Non retenu après entretien', label: 'Non retenu après entretien',
        style: { backgroundColor: '#cd5c5c', color: 'white' }
      },
      {
        value: 'Recrutement confirmé', label: 'Recrutement confirmé',
        style: { backgroundColor: '#00a550', color: 'white' } 
      },
       {
    value: 'brouillon', label: 'Brouillon',
    style: { backgroundColor: '#f59e0b', color: 'white' } 
  },
    ];


        export const recruteurCandidatureStatus  = [
        {
      value: 'A traiter', label: 'Candidature envoyée',
      style: { backgroundColor: '#000000', color: 'white' }
      },
      {
        value: 'Refusé avant entretien',  label: 'Refusé avant entretien',
        style: { backgroundColor: '#cd5c5c', color: 'white' }
      },
      {
        value: 'Accepté pour entretien', label: 'Accepté pour entretien',
        style: { backgroundColor: '#0076b6', color: 'white' } 
      },
      {
        value: 'Non retenu après entretien', label: 'Non retenu après entretien',
        style: { backgroundColor: '#cd5c5c', color: 'white' }
      },
      {
        value: 'Recrutement confirmé', label: 'Recrutement confirmé',
        style: { backgroundColor: '#00a550', color: 'white' } 
      },
       {
    value: 'Brouillon', label: 'Brouillon',
    style: { backgroundColor: '#f59e0b', color: 'white' } 
  },
    ];
    
    //status de agent et commercial cvtheque
    export const statusOptions = [
      {
        value: '',
        label: 'Status',
        style: { backgroundColor: '#999999', color: 'white' } 
      },
      {
        value: 'A traiter',
        label: 'A traiter',
        style: { backgroundColor: '#000000', color: 'white' }
      },
      {
        value: 'En cours de traitement',
        label: 'En cours de traitement',
        style: { backgroundColor: '#ff8c00', color: 'white' }
      },
      {
        value: 'À recontacter',
        label: 'À recontacter',
        style: { backgroundColor: '#ff8c00', color: 'white' }
      },
      {
        value: 'Hors perimetre',
        label: 'Hors périmètre',
        style: { backgroundColor: '#cd5c5c', color: 'white' }
      },
      {
        value: 'Refus reference',
        label: 'Refus d’être référencé(e)',
        style: { backgroundColor: '#cd5c5c', color: 'white' }
      },
      {
        value: 'Injoignable',
        label: 'Injoignable',
        style: { backgroundColor: '#ff8c00', color: 'white' }
      },
      {
        value: 'Qualifie attente controle',
        label: 'Qualifié',
        style: { backgroundColor: '#0076b6', color: 'white' }
      },
      {
        value: 'Valide apres controle',
        label: 'Validé après contrôle',
        style: { backgroundColor: '#00a550', color: 'white' }
      },
      {
        value: 'Rejete apres controle',
        label: 'Rejeté après contrôle',
        style: { backgroundColor: '#cd5c5c', color: 'white' }
      },
      {
        value: 'Recruté',
        label: 'Recruté',
        style: { backgroundColor: '#00a550', color: 'white' }
      },
      {
        value: 'brouillon',
        label: 'Brouillon',
        style: { backgroundColor: '#cd5c5c', color: 'white' }
        }
    ];
    
    export const MODEL_LABELS = {
      option1: "Modèle 1",
      option2: "Modèle 2",
      option3: "Modèle 3"
    };
    //Ajout mission
    export const RoleOptions = [
      { value: 'Manager métier', label: 'Manager métier' },
      { value: 'Responsable RH', label: 'Responsable RH' },
      { value: 'Recruteur technique', label: 'Recruteur technique' },
      { value: 'Consultant externe', label: 'Consultant externe' },
      { value: 'Chef de projet', label: 'Chef de projet' },
    ];

    